export interface TransactionInfo {
	transaction_id: string;
	asset_id: string;
	account_id: string;
	wallet_id: string;
	asset_amount: string;
	asset_symbol: string;
	fee_amount: string;
	transaction_type: string;
	operation_type: string;
	flow: string;
	created_at: string;
	required_user_actions: [];
	payment_data: TransactionInfoPaymentData;
}

export interface TransactionInfoPaymentData {
	transaction_status: TransactionInfoStatus;
	broker_transaction_status: string;
	sender_legal_name: string;
	receiver_legal_name: string;
	user_owned: boolean | null;
	coin_network_id: string;
	wallet_host: string;
	wallet_host_name: string;
	wallet_address: string;
	tx_hash: null;
	merchant_reference: string;
	iban: string;
	bic: string;
	card_number: string;
}

export enum TransactionInfoStatus {
	INITIATED = "INITIATED",
	PENDING = "PENDING",
	APPROVED = "APPROVED",
	PROCESSING = "PROCESSING",
	FINISHED = "FINISHED",
	REJECTED = "REJECTED",
	CANCELLED = "CANCELLED",
	REFUNDED = "REFUNDED"
}

export const statusColorMapping: Map<TransactionInfoStatus, string> = new Map([
	[TransactionInfoStatus.INITIATED, "status-color-pending"],
	[TransactionInfoStatus.PENDING, "status-color-pending"],
	[TransactionInfoStatus.PROCESSING, "status-color-pending"],
	[TransactionInfoStatus.APPROVED, "status-color-success"],
	[TransactionInfoStatus.FINISHED, "status-color-success"],
	[TransactionInfoStatus.REJECTED, "status-color-cancelled"],
	[TransactionInfoStatus.CANCELLED, "status-color-cancelled"],
	[TransactionInfoStatus.REFUNDED, "status-color-cancelled"]
]);

export const statusTranslationKeyMapping: Map<TransactionInfoStatus, string> = new Map([
	[TransactionInfoStatus.INITIATED, "initiated"],
	[TransactionInfoStatus.PENDING, "on_hold"],
	[TransactionInfoStatus.PROCESSING, "processing_alt_text"],
	[TransactionInfoStatus.APPROVED, "tx_status_approved"],
	[TransactionInfoStatus.FINISHED, "finished"],
	[TransactionInfoStatus.REJECTED, "rejected"],
	[TransactionInfoStatus.CANCELLED, "canceled"],
	[TransactionInfoStatus.REFUNDED, "tx_status_refunded"]
]);
